import styled from 'styled-components';

const SpecContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  margin-top: 10px;

  @media (max-width: 768px) {
    margin-top: 15px;
  }

  @media (max-width: 480px) {
    margin-top: 10px;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-radius: 15px;
  overflow: hidden;
  border: 2px solid #e74c3c;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }

  @media (max-width: 480px) {
    font-size: 0.8rem;
  }
`;

const TableRow = styled.tr`
  border-bottom: ${(props) => (props.isLast ? 'none' : '1px solid #cecece')};
  height: 34px;

  @media (max-width: 480px) {
    height: auto;
  }
`;

const TableHeadItem = styled.th`
  padding: 8px 12px;
  background-color: #f0f0f0;
  border: 1px solid #cecece;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  font-weight: bold;
  color: #333;
`;

const TableDataItem = styled.td`
  padding: 8px 12px;
  border: 1px solid #cecece;
  background-color: #fff;
  vertical-align: middle;
  text-align: center;
  color: #333;
`;

const SpecLabelCell = styled.td`
  padding: 8px 12px;
  border: 1px solid #cecece;
  background-color: #f0f0f0;
  vertical-align: middle;
  text-align: left;
  font-weight: bold;
  color: #333;
`;

const SpecTitle = styled.h3`
  font-size: 1.2rem;
  margin: 10px 0;
  font-weight: bold;
  color: ${(props) => props.theme.colors.black};

  @media (max-width: 768px) {
    font-size: 1.1rem !important;
    margin: 8px 0 !important;
  }

  @media (max-width: 480px) {
    font-size: 1rem !important;
    margin: 6px 0 !important;
  }
`;

const SpecificationTable = ({ product, productSpecifications }) => {
  if (!product) {
    return null;
  }

  const getDataByCode = (code) => {
    if (!Array.isArray(productSpecifications)) {
      return {};
    }
    return productSpecifications.find((item) => item.code === code) || {};
  };

  const unitData = getDataByCode('UNIT');
  const packData = getDataByCode('PACK');
  const cartonData = getDataByCode('CTN');

  // Get common values from unitData (should be same across all codes)
  const color = unitData.Color || '';
  const material = unitData.material || '';
  const country = unitData.countryOfOrigin || '';

  return (
    <SpecContainer>
      <SpecTitle>Specifications</SpecTitle>
      <Table>
        <thead>
          <TableRow>
            <TableHeadItem></TableHeadItem>
            <TableHeadItem>Unit</TableHeadItem>
            <TableHeadItem>Pack</TableHeadItem>
            <TableHeadItem>Carton</TableHeadItem>
          </TableRow>
        </thead>
        <tbody>
          <TableRow>
            <SpecLabelCell>Width</SpecLabelCell>
            <TableDataItem>{unitData.width || ''}</TableDataItem>
            <TableDataItem>{packData.width || ''}</TableDataItem>
            <TableDataItem>{cartonData.width || ''}</TableDataItem>
          </TableRow>
          <TableRow>
            <SpecLabelCell>Height</SpecLabelCell>
            <TableDataItem>{unitData.height || ''}</TableDataItem>
            <TableDataItem>{packData.height || ''}</TableDataItem>
            <TableDataItem>{cartonData.height || ''}</TableDataItem>
          </TableRow>
          <TableRow>
            <SpecLabelCell>Length</SpecLabelCell>
            <TableDataItem>{unitData.length || ''}</TableDataItem>
            <TableDataItem>{packData.length || ''}</TableDataItem>
            <TableDataItem>{cartonData.length || ''}</TableDataItem>
          </TableRow>
          <TableRow>
            <SpecLabelCell>Color</SpecLabelCell>
            <TableDataItem colSpan='3'>{color}</TableDataItem>
          </TableRow>
          <TableRow>
            <SpecLabelCell>Material</SpecLabelCell>
            <TableDataItem colSpan='3'>{material}</TableDataItem>
          </TableRow>
          <TableRow>
            <SpecLabelCell>Country of Origin</SpecLabelCell>
            <TableDataItem colSpan='3'>{country}</TableDataItem>
          </TableRow>
        </tbody>
      </Table>
    </SpecContainer>
  );
};

export default SpecificationTable;
